import { useEffect } from 'react';
import { useSelector } from 'react-redux';

function useSaveShortcutV1(onSave = () => { },...rest) {
    const isDrawerOpen = useSelector((state) => state.sidebarReducer?.settings);
    const isQuickDrawerOpen = useSelector(
        (state) => state.sidebarReducer?.QuickLinks
    );
    let restrict = () => {
        const ids = ["invoiseCancel", "supportModal", "themeSelection", "voucherSettings", "addPartyGroup", "listPartyGroup", "ModalWhileSave", "cancelSave", "leavePage","partyCreationModal"]; // Your list of IDs
        const anyElementExists = () => ids.some(id => document.getElementById(id) !== null);
        if (anyElementExists()) {
            return false
        }
        else {
            return !isDrawerOpen && !isQuickDrawerOpen
        }
    }
    useEffect(() => {
 const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 's' && restrict()) {
                e.preventDefault();
                onSave();
            }
        };
        if(rest.find(item=>item)){
            console.log(rest,"")
            console.log(rest.find(item=>item))
            window.removeEventListener('keydown', handleKeyDown);
            
        }else{
            window.addEventListener('keydown', handleKeyDown);

        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onSave,rest]);
}

export default useSaveShortcutV1;
